import sundayrunday from "../../images/sandiego/sundayrunday.png";
import pbrc from "../../images/sandiego/pbrc.png";
import obrunclub from "../../images/sandiego/obrc.png";
import runnorthcounty from "../../images/sandiego/rnc.png";
import ultrabuds from "../../images/sandiego/ultrabuds.png";
import twr from "../../images/sandiego/twr.png";

export const SAN_DIEGO_CLUB_PROFILES = {
    "sundayrunday": {
        id: "sundayrunday",
        title: "Sunday Runday SD Run Club",
        images: [sundayrunday],
        isVerified: true,
        badges: ["free", "weekly", "social"],
        whatToExpect: "Start your Sunday the right way with a refreshing morning run, seeing some of San Diego's best spots.",
        howToJoin: "Just show up at the meeting location and join the crew! The club rotates routes – so be sure to check their Instagram to keep up to date with where to meet!",
        description: "Sunday Runday SD is a welcoming running club in San Diego that combines running, yoga, and social vibes. Expect scenic routes, supportive runners, and post-run refreshments!",
        subtitle: "San Diego",
        whyWeLikeIt: "Sunday Runday love building community. In their own words: 'communities are at the heart of human connection'. Check out their Instagram for some of their past events!",
        socialInfo: [
            "Post-run socials",
            "Medium group size",
            "All running abilities",
            "Solo-friendly"
        ],
        contactInfo: [
            {
                name: "Instagram",
                url: "https://www.instagram.com/sundayrundayclub/",
                platform: "instagram",
            }
        ],
        meetPoint: {
            details: ["Mike Hess Brewery, 809 W Harbor Dr. Unit E4, San Diego, CA 92101"],
            link: {
                text: "Mike Hess Brewery",
                url: "https://maps.app.goo.gl/ZVJpm2MhUJJtk4kL9",
            },
        },
        runDays: [
            {
                day: "Sunday",
                times: ["9:00 AM"],
                distance: "Varied",
                location: "Locations vary",
                googleMapLink: ""
            }
        ],
        joinLink: "",
        instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/sundayrundayclub/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/sundayrundayclub/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this profile on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/sundayrundayclub/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px;" target="_blank">Sunday Runday SD Run Club</a> (@<a href="https://www.instagram.com/sundayrundayclub/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px;" target="_blank">sundayrundayclub</a>) • Instagram photos and videos</p></div></blockquote>
<script async src="//www.instagram.com/embed.js"></script>`
    },

    "pbrc": {
  id: "pbrc",
  title: "Pacific Beach Run Club",
  images: [pbrc],
  isVerified: true,
  badges: ["free", "weekly"],
  whatToExpect: "Join the Pacific Beach Run Club for scenic group runs along San Diego’s beautiful coastline. With multiple weekly runs at Fanuel Park, expect a fun and welcoming environment where runners of all paces can feel at home. Plus, there's a post-run social to connect with fellow runners over coffee!",
  howToJoin: "Simply show up at Fanuel Park at the scheduled time—no sign-up required!",
  description:
    "Pacific Beach Run Club (PBRC) is one of San Diego’s most active and social running clubs. Whether you’re looking for a consistent running routine, a way to meet fellow runners, or just want to enjoy a scenic jog, PBRC has you covered. Runs operate in an accordion style, with built-in stops to ensure runners of all paces can stay together. Don't forget to check out their post-run hangouts at Java Earth Coffee!",
  subtitle: "San Diego",
  whyWeLikeIt:
    "A friendly and well-structured running club that makes it easy for everyone to join. Plus, their post-run coffee hangouts are a great way to connect with the local running community!",
  socialInfo: [
    "Post-run social",
    "Medium group size",
    "9:00/mi front-run pace",
    "All running abilities welcome",
  ],
  contactInfo: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/pbrunclub",
      platform: "instagram",
    },
    {
      name: "Website",
      url: "https://www.narunclub.com/pbrc",
      platform: "website",
    },
  ],
  meetPoint: {
    details: ["Fanuel Park"],
    link: {
      text: "Fanuel Park",
      url: "https://maps.app.goo.gl/ZVJpm2MhUJJtk4kL9",
    },
  },
  runDays: [
    {
      day: "Wednesday",
      times: ["6:30 PM"],
      distance: "3 miles",
      location: "Fanuel Park",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d70517.65378730939!2d-117.2449774085442!3d32.77768172421033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dc01e82cf2b941%3A0xf110a3bd70f54fe5!2sFanuel%20Street%20Park!5e0!3m2!1sen!2sus!4v1739675940607!5m2!1sen!2sus",
    },
    {
      day: "Saturday",
      times: ["8:30 AM"],
      distance: "3.6 miles",
      location: "Fanuel Park",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d70517.65378730939!2d-117.2449774085442!3d32.77768172421033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dc01e82cf2b941%3A0xf110a3bd70f54fe5!2sFanuel%20Street%20Park!5e0!3m2!1sen!2sus!4v1739675940607!5m2!1sen!2sus",
    },
  ],
  joinLink: "https://www.narunclub.com/pbrc",
  instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/pbrunclub/" data-instgrm-version="14"></blockquote><script async src="//www.instagram.com/embed.js"></script>`,
},

"obrunclub": {
  id: "obrunclub",
  title: "Ocean Beach Run Club",
  images: [obrunclub],
  isVerified: true,
  badges: ["free", "weekly"],
  whatToExpect: "Join the Ocean Beach Run Club for a scenic and social run in San Diego’s coastal gem, Ocean Beach. Whether you're looking for an evening or morning run, OB Run Club has you covered with multiple group runs each week. All paces are welcome!",
  howToJoin: "Simply show up at the designated meeting points—no sign-up required!",
  description:
    "The Ocean Beach Run Club (OB Run Club) is a laid-back and welcoming running community in San Diego, designed for runners of all paces. Meet at Robb Field on Tuesday nights for a casual 5K or 5-mile run, or start your day right with a Thursday morning coastal run from Brew Wave Coffee. Expect good vibes, coastal views, and a friendly running crew!",
  subtitle: "San Diego",
  whyWeLikeIt:
    "A no-frills, welcoming run club in one of San Diego’s most scenic neighborhoods. Plus, post-run coffee at Brew Wave Coffee is always a win!",
  socialInfo: [
    "Post-run coffees",
    "Medium group size",
    "All running abilities",
  ],
  contactInfo: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/obrunclub/",
      platform: "instagram",
    },
  ],
  meetPoint: {
    details: ["Robb Field & Brew Wave Coffee"],
    link: {
      text: "Robb Field",
      url: "https://maps.app.goo.gl/ZVJpm2MhUJJtk4kL9",
    },
  },
  runDays: [
    {
      day: "Tuesday",
      times: ["6:00 PM"],
      distance: "5K to 5 miles",
      location: "Robb Field (2525 Bacon St, 92107)",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.349518643894!2d-117.2431450215633!3d32.754423910984755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80deab641738437b%3A0xd1cb51625545d0c6!2sRobb%20Field%20Recreation%20Center!5e0!3m2!1sen!2sus!4v1739677678962!5m2!1sen!2sus",
    },
    {
      day: "Thursday",
      times: ["7:00 AM"],
      distance: "4-6 miles",
      location: "Brew Wave Coffee",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21970.592788292834!2d-117.26795966040284!3d32.74024290113275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80deaba251843fef%3A0xb2b8fae417a4044e!2sBrew%20Wave%20Coffee!5e0!3m2!1sen!2sus!4v1739677769381!5m2!1sen!2sus",
    },
  ],
  joinLink: "https://www.instagram.com/obrunclub/",
  instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/obrunclub/" data-instgrm-version="14"></blockquote><script async src="//www.instagram.com/embed.js"></script>`,
},

"runnorthcounty": {
  id: "runnorthcounty",
  title: "Run North County",
  images: [runnorthcounty],
  isVerified: true,
  badges: ["free", "weekly"],
  whatToExpect: "Run North County is a welcoming community of runners in North County San Diego. Whether you're looking for a scenic coastal jog, a trail adventure, or a social run with post-run drinks, there's a run for everyone. All paces are welcome!",
  howToJoin: "Simply show up at the designated meeting points—no registration required!",
  description:
    "Run North County is a non-profit running community that connects runners across North County San Diego. With multiple weekly group runs, from scenic coastal routes in Encinitas to speedwork sessions in Carlsbad, this club is a hub for both social and serious runners. Many of their runs end at local coffee shops and breweries, making it a great place to meet like-minded runners.",
  subtitle: "San Diego - North County",
  whyWeLikeIt:
    "A vibrant running community offering a variety of runs, from trails to pavement, and a strong focus on giving back to local charities.",
  socialInfo: [
    "Post-run socials",
    "Large group size",
    "All running abilities",
    "Trail and road runs"
  ],
  contactInfo: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/run_north_county/",
      platform: "instagram",
    },
    {
      name: "Website",
      url: "https://www.runnorthcounty.com/",
      platform: "website",
    },
  ],
  meetPoint: {
    details: ["Encinitas, San Marcos, Carlsbad"],
    link: {
      text: "Pannikin Coffee Shop, Encinitas",
      url: "https://maps.app.goo.gl/WZ7MhtZdR5yDhh3w8",
    },
  },
  runDays: [
    {
      day: "Saturday",
      times: ["7:30 AM"],
      distance: "3-23 miles (8-mile recommended)",
      location: "Pannikin Coffee Shop, Leucadia",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3343.930228419332!2d-117.3022224238474!3d33.058303669557176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dc0cf62d8efda3%3A0xa13cc131462c34c2!2sPannikin%20Coffee%20%26%20Tea!5e0!3m2!1sen!2sus!4v1739679394642!5m2!1sen!2sus",
    },

  ],
  joinLink: "https://www.runnorthcounty.com/",
  instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/run_north_county/" data-instgrm-version="14"></blockquote><script async src="//www.instagram.com/embed.js"></script>`,
},

"ultrabudsrunclub": {
  id: "ultrabudsrunclub",
  title: "Ultrabuds Run Club",
  images: [ultrabuds],
  isVerified: true,
  badges: ["social", "free"],
  whatToExpect: "A welcoming community of ultra and trail runners who share a passion for long-distance running and post-run socializing with great beer and wine.",
  howToJoin: "Follow their Instagram or Facebook group for run announcements and meetup details.",
  description:
    "Ultrabuds Run Club is a community of ultra and trail runners based in San Diego, with additional groups in West Texas, Eagle, ID, and Raleigh, NC. Known for their love of long-distance running and post-run social hangouts, they bring together runners who enjoy both endurance challenges and a good drink afterward. Whether you're training for your next ultra or just looking for a fun group to run with, Ultrabuds has you covered.",
  subtitle: "San Diego",
  whyWeLikeIt:
    "Trail-loving ultra runners who mix long miles with great social vibes—what’s not to love?",
  socialInfo: [
    "Post-run social",
    "Medium group size",
    "Trail and ultra runners",
    "All running abilities"
  ],
  contactInfo: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/ultrabuds/",
      platform: "instagram",
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/groups/ultrabudsrunning/",
      platform: "facebook",
    },
  ],
  meetPoint: {
    details: ["Varies – check Instagram or Facebook for updates"],
    link: {
      text: "Ultrabuds Facebook Group",
      url: "https://www.facebook.com/groups/ultrabudsrunning/",
    },
  },
  runDays: [],
  joinLink: "https://www.facebook.com/groups/ultrabudsrunning/",
  instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/ultrabuds/" data-instgrm-version="14"></blockquote><script async src="//www.instagram.com/embed.js"></script>`,
},

"tuesdayswaterfrontrun": {
  id: "tuesdayswaterfrontrun",
  title: "Tuesdays Waterfront Run",
  images: [twr],
  isVerified: true,
  badges: ["social", "free", "evening"],
  whatToExpect: "A scenic and social 3-5 mile run along the Downtown San Diego waterfront every Tuesday at 6 PM.",
  howToJoin: "Meet at Waterfront Park in Downtown San Diego at 6 PM on Tuesdays.",
  description:
    "Tuesdays Waterfront Run is a community-focused running club that welcomes all paces and abilities. Every Tuesday at 6 PM, runners gather at Waterfront Park for a scenic 3-5 mile run along the beautiful San Diego waterfront. Whether you're looking to improve your pace, meet fellow runners, or just enjoy the views, this is the perfect midweek run club in San Diego.",
  subtitle: "San Diego",
  whyWeLikeIt:
    "A relaxed yet engaging community run in one of San Diego’s most scenic spots. Perfect for all levels!",
  socialInfo: [
    "Post-run social",
    "Medium group size",
    "All running abilities",
    "Evening run",
  ],
  contactInfo: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/tuesdayswaterfrontrun/",
      platform: "instagram",
    },
  ],
  meetPoint: {
    details: ["Waterfront Park, San Diego"],
    link: {
      text: "Waterfront Park",
      url: "https://maps.app.goo.gl/Xm8Y9KbFJQ2KzV1X6", // Replace with actual link if available
    },
  },
  runDays: [
    {
      day: "Tuesday",
      times: ["6:00 PM"],
      distance: "3-5 miles",
      location: "Waterfront Park, San Diego",
      googleMapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3356.6693008115585!2d-117.17485657385777!3d32.72141418682476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d954ad5d44a503%3A0x99bb37dd2b343cba!2sWaterfront%20Park!5e0!3m2!1sen!2sus!4v1739680826676!5m2!1sen!2sus", // Replace with actual link if available
    }
  ],
  joinLink: "https://www.instagram.com/tuesdayswaterfrontrun/",
  instagramEmbed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/tuesdayswaterfrontrun/" data-instgrm-version="14"></blockquote><script async src="//www.instagram.com/embed.js"></script>`,
},





};


